import { Company } from "@repo/types";

export function getValidCompanyUrl(logo?: Company["logo"]) {
  // Return null if logo or url is undefined
  if (!logo?.url) {
    return null;
  }

  // if the company logo url doesn't start with http, add the base url
  const companyImageUrl = logo.url.startsWith("http")
    ? logo.url
    : `${process.env.NEXT_PUBLIC_BASE_URL}${logo.url}`;

  // Check for placeholder images
  const isPlaceholderImage =
    companyImageUrl.endsWith("nopic.jpg") ||
    companyImageUrl.endsWith("nopic.png");

  return isPlaceholderImage ? null : companyImageUrl;
}
